angular
    .module('empower.userProfile')
    .controller('userProfileController', ['$rootScope', '$scope', 'userProfileService', 'popupService', 'userProfileConst',
        function ($rootScope, $scope, userProfileService, popupService, userProfileConst) {

            $scope.pageBreadcrumbs = [{ url: '/', title: 'Home' }, { url: null, title: 'My Profile' }];
            $rootScope.pageName = "My Profile";
            $scope.editMode = false;          
            // data sources for Contact Preferences
            $scope.preferredContactNumber = userProfileConst.PREFERRED_CONTACT_NUMNER;
            $scope.preferredCommunicationType = userProfileConst.PREFERRED_METHOD_COMMUNICATION;
            $scope.preferredTimeToContact = userProfileConst.PREFERRED_TIME_TO_CONTACT;

            // init dialog option
            var dialogOtpions = {
                //okCallback: $scope.cancel,
                //additionClass: 'popup-box-small'
            };

            $scope.profileForm = {};

            // init the page
            $scope.init = function () {
                userProfileService.getUserProfile().then(function (response) {
                    $scope.userProfile = response;
                    if ($scope.userProfile.PreferredCommunicationType == null) {
                        $scope.userProfile.PreferredCommunicationType = 1;
                    }
                    if ($scope.userProfile.PreferredContactNumnerType == null) {
                        $scope.userProfile.PreferredContactNumnerType = 2;
                    }
                    $rootScope.profileId = $scope.userProfile.ProfileId;
                    $scope.userProfile.SameAsAddress = $scope.userProfile.Street == $scope.userProfile.PostalStreet & $scope.userProfile.Suburb == $scope.userProfile.PostalSuburb & $scope.userProfile.State == $scope.userProfile.PostalState & $scope.userProfile.PostCode == $scope.userProfile.PostalPostCode;
                    $scope.userOriginalProfile = angular.copy($scope.userProfile);
                });
            }

            // Submit to change profile event
            $scope.updateProfile = function () {

                // validate if no changes
                if (!$scope.validate()) {
                    popupService.showDialog("No changes have been recorded. Please select Edit Profile to update your details.", undefined, dialogOtpions);
                    reset();
                }
                else {

                    userProfileService.updateProfile($scope.userProfile).then(function (response) {

                        // check no changes retunrs from back end
                        if (response.IsNoChange) {
                            popupService.showDialog("No changes have been recorded. Please select Edit Profile to update your details.", undefined, dialogOtpions);
                            reset();
                        } else {
                            $scope.userProfile.ProfileId = response.ProfileId;
                            var msg = response.IsNotified ? "Please allow up to 48 hours for these changes to take effect." : "Your profile has been updated.";
                            if ($scope.userProfile.ProfileId) {
                                popupService.showDialog(msg, undefined, dialogOtpions);
                                $scope.userOriginalProfile = angular.copy($scope.userProfile);
                                reset();
                            }
                        }
                    });
                }
            }

            $scope.edit = function () {
                $scope.editMode = true;
            }

            $scope.cancel = function () {
                $scope.userProfile = angular.copy($scope.userOriginalProfile);
                reset();
            }

            $scope.validate = function () {

                if (angular.equals($scope.userOriginalProfile, $scope.userProfile)) {
                    return false;
                }

                return true;
            }

            $scope.checkSameAsAddress = function () {
                if ($scope.userProfile.SameAsAddress) {
                    $scope.userProfile.PostalStreet = $scope.userProfile.Street;
                    $scope.userProfile.PostalSuburb = $scope.userProfile.Suburb;
                    $scope.userProfile.PostalState = $scope.userProfile.State;
                    $scope.userProfile.PostalPostCode = $scope.userProfile.PostCode;
                }
            }

            $scope.clickUpdateBankDetails = function () {
                var otpions = {
                    showHeader: false,
                    showCloseButton: false,
                    otherTheme: true
                };

                popupService.show('userProfile', 'user-bank-detail', otpions);
            };

            $scope.clickDeactivateAccount = function () {
                if($scope.userProfile.ProfileType === 3) {
                    popupService.showDialog('<p>You are the primary contact associated to a policy and therefore cannot deactivate your account without nominating a new primary contact.</p> <p>If you no longer wish to use EMpower please contact your Client Services representative, alternatively, please email <a href = "mailto: empower@eml.com.au">empower@eml.com.au</a>.</p>', undefined, {});
                } else {
                    if($scope.userProfile.ProfileType === 1) {
                        popupService.showMultiActionDialog(
                            '<p>You have selected to deactivate your EMpower account. If you continue you will no longer be able to access your details in EMpower.</p> <p>Do you wish to continue?</p>',
                            undefined, [{
                                    text: 'Cancel',
                                    buttonClass: 'button-primary',
                                    actionCallback: popupService.hide
                                }, {
                                    text: 'Deactivate',
                                    buttonClass: 'button-secondary',
                                    actionCallback: $scope.deactivateAccount,
                                }
                        ]);
                    } else {
                        var deactivatePopupOtpions = {
                            showHeader: false,
                            showCloseButton: false,
                            otherTheme: false,
                            additionClass: 'warning-popup'
                        };
        
                        popupService.show('userProfile', 'deactivate-warning', deactivatePopupOtpions);
                    }
                }
            };

            // Submit to change bank detail
            $scope.updateBankDetail = function () {
                userProfileService.updateBankDetails($scope.userProfile).then(function (response) {                                       
                    $scope.userProfile.ProfileId = response.ProfileId;
                    var msg = response.IsNotified ? "Please allow up to 48 hours for these changes to take effect." : "Your profile has been updated.";
                    if ($scope.userProfile.ProfileId) {
                        popupService.showDialog(msg, undefined, dialogOtpions);
                        //$scope.userOriginalProfile = angular.copy($scope.userProfile);
                        //reset();
                    }
                });

            };

            function reset() {
                $scope.editMode = false;
                $scope.profileForm.$setPristine();
            }

            $scope.deactivateAccount = function() {
                userProfileService.deactivateAccount().then(function (response) {
                    if (response.IsSuccess) {
                        popupService.hide();
                        $rootScope.userLogout();
                    } else {
                        popupService.showError(response.ErrorMessage);
                    }
                })
            }
        }]);
